export default __webpack_public_path__ + "static/media/location.d7400ee8.svg";